import { observer } from 'mobx-react-lite'
import { useNavigate } from 'react-router'
import { type IButtonProps, Icon, Typography } from 'shared/ui'
import { LINK_COMPLIANCE_LEARN_MORE_LINK } from 'shared/constants/links.ts'
import { useCompliancePageContext } from 'pages/settings/pages/compliance/context'
import { RegisterSection } from 'pages/settings/pages/compliance/ui/RegisterSection/RegisterSection'
import { SummaryLocalNumbers } from 'pages/settings/pages/compliance/ui/Summary/SummaryLocalNumbers'
import styles from 'pages/settings/pages/compliance/ui/styles.module.scss'
import { CompliancePath } from 'pages/settings/pages/compliance/route/compliancePath.ts'

export const LocalNumbersPage = observer(() => {
  const { localNumbersPageStore } = useCompliancePageContext()
  const navigate = useNavigate()

  const { campaignData, registerButtonText, onRegister, complianceLayerStore } =
    localNumbersPageStore

  const actionButton: IButtonProps | undefined =
    (registerButtonText && {
      text: registerButtonText,
      onClick: onRegister,
    }) ||
    (complianceLayerStore.isCanUpgradePackage && {
      text: 'Upgrade package',
      onClick: () => {
        navigate(CompliancePath.compliance.upgrade10DLCPackage.root)
      },
      icon: 'arrowUp',
      contained: 'secondary',
    }) ||
    undefined

  return (
    <div className={styles.sections}>
      <RegisterSection
        title={'A2P 10DLC registration'}
        titleType={'body-lg-medium'}
        desc={
          <Typography
            ariaLabel='Local-number_verification_desc'
            variant='body-md-regular'
            tag='div'
            className={styles.tollFreeVerificationDesc}
          >
            Required for sending SMS <Icon icon='arrowRight' className={styles.arrow} /> to
            <Icon className={styles.flag} icon='flagUSA' /> US.
          </Typography>
        }
        isSecondStep={campaignData?.isSubmitted}
        learnMoreLink={LINK_COMPLIANCE_LEARN_MORE_LINK}
        actionButton={actionButton}
        containerClassName={styles.sectionNoMargin}
      />
      <SummaryLocalNumbers />
    </div>
  )
})
